import { render, staticRenderFns } from "./goods-list-item.vue?vue&type=template&id=3475efdb&scoped=true"
import script from "./goods-list-item.vue?vue&type=script&lang=js"
export * from "./goods-list-item.vue?vue&type=script&lang=js"
import style0 from "./goods-list-item.vue?vue&type=style&index=0&id=3475efdb&prod&lang=css"
import style1 from "./goods-list-item.vue?vue&type=style&index=1&id=3475efdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3475efdb",
  null
  
)

export default component.exports